import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";
import { ADD_PROJECT, ADD_PROJECT_BUDGET_ALLOCATION, ADD_PROJECT_BUDGET_SPENT, ADD_PROJECT_CAMP_LEAD, ADD_PROJECT_CONTACT, ADD_PROJECT_EMAIL_COMP_FILTER, ADD_PROJECT_FEATURE, ADD_PROJECT_GALLERY, ADD_PROJECT_LINK, ADD_PROJECT_MARKET, ADD_PROJECT_MEDIA, ADD_SETTING_WORKSHEET, DELETE_PROJECT, DELETE_PROJECT_BUDGET_ALLOCATION, DELETE_PROJECT_BUDGET_SPENT, DELETE_PROJECT_CAMP_LEAD, DELETE_PROJECT_CONTACT, DELETE_PROJECT_FEATURE, DELETE_PROJECT_GALLERY, DELETE_PROJECT_LINK, DELETE_PROJECT_MARKET, DELETE_PROJECT_MEDIA, DELETE_SETTING_WORKSHEET, GET_ALL_PROJECT, GET_ALL_PROJECT_CLIENT, GET_ALL_PROJECT_LEAD, GET_ALL_PROJECT_SEARCH, GET_ALL_PROJECT_SEARCH_SUCCESS, GET_ALL_PROJECT_UUID, GET_PROJECT_BUDGET_ALLOCATION, GET_PROJECT_BUDGET_SPENT, GET_PROJECT_CAMP_LEAD, GET_PROJECT_CONTACT, GET_PROJECT_FEATURE, GET_PROJECT_FEATURE_STANDARD, GET_PROJECT_GALLERY, GET_PROJECT_LINK, GET_PROJECT_MARKET, GET_PROJECT_MEDIA, GET_SETTING_WORKSHEET, SEND_LEAD_WORKSHEET, UPDATE_MPROJECT_STAUS, UPDATE_PROJECT, UPDATE_PROJECT_BUDGET_ALLOCATION, UPDATE_PROJECT_BUDGET_SPENT, UPDATE_PROJECT_CONTACT, UPDATE_PROJECT_FEATURE, UPDATE_PROJECT_FEATURE_STANDARD, UPDATE_PROJECT_MARKET,ADD_PROJECT_OPEN_HOUSE_FILE,GET_ALL_PROJECT_OPEN_HOUSE_FILE,ADD_PROJECT_OPEN_HOUSE,GET_ALL_PROJECT_OPEN_HOUSE,GET_PROJECT_OPEN_HOUSE,DELETE_PROJECT_OPEN_HOUSE,UPDATE_PROJECT_OPEN_HOUSE,ADD_PROJECT_DOWNLOAD_PRICE_FILE,ADD_PROJECT_DOWNLOAD_PRICE,GET_ALL_PROJECT_DOWNLOAD_PRICE,GET_PROJECT_DOWNLOAD_PRICE,DELETE_PROJECT_DOWNLOAD_PRICE,UPDATE_PROJECT_DOWNLOAD_PRICE, GET_PROJECT_OPEN_HOUSE_FILE, DELETE_PROJECT_OPEN_HOUSE_FILE, GET_PROJECT_DOWNLOAD_PRICE_FILE, DELETE_PROJECT_DOWNLOAD_PRICE_FILE, GET_PROJECT_WORKSHEET_LEAD, GET_PROJECT_WORKSHEET_LEAD_PUR_DETAIL, GET_PROJECT_WORKSHEET_LEAD_UNIT_DETAIL, GET_PROJECT_WORKSHEET_LEAD_DOC_DETAIL, POST_PROJECT_INVITE, GET_PROJECT_INVITE, DELETE_PROJECT_INVITE, VIEW_PROJECT_INVITE_ATTENDEES, UPDATE_PROJECT_LINK, UPDATE_PROJECT_WORKSHEET_UNIT, GET_PROJECT_WORKSHEET_UNIT_INFO, GET_PROJECT_LEAD_BY_WORKSHEET_STATUS, GET_PROJECT_INVITE_DETAIL, UPDATE_PROJECT_INVITE, GET_ALL_PROJECT_LANDING_PAGE, POST_PROJECT_OPEN_HOUSE_FORM, GET_PROJECT_OPEN_HOUSE_FORM } from "./actionTypes"
import { projectapiError, addProjectSuccess, addProjectFeatureSuccess, addProjectFeatureFail, addProjectContactSuccess, addProjectContactFail, getProjectContactSuccess, getProjectContactFail, addProjectMediaSuccess, addProjectMediaFail, getProjectMediaSuccess, getProjectMediaFail, addProjectMarketSuccess, addProjectMarketFail, getProjectMarketSuccess, getProjectMarketFail, getAllProjectAction, getAllProjectActionFail, getAllProjectActionSuccess, getProjectUUIDActionSuccess, getProjectUUIDActionFail, getProjectFeatureActionSuccess, getProjectFeatureActionFail, addProjectError, deleteProjectSuccess, deleteProjectFail, projectUpdateSuccess, projectUpdateError, updateProjectContactSuccess, updateProjectContactFail, updateProjectFeatureSuccess, updateProjectFeatureFail, deleteProjectContact, deleteProjectContactSuccess, deleteProjectContactFail, deleteProjectDocumentSuccess, deleteProjectDocumentFail, updateProjectMarketSuccess, updateProjectMarketFail, deleteProjectMarketSuccess, deleteProjectMarketFail, addProjectLinkSuccess, getProjectLinkSuccess, addProjectLinkFail, getProjectLinkFail, deleteProjectLinkSuccess, deleteProjectLinkFail, addProjectGallerySuccess, getProjectGallarySuccess, addProjectGalleryFail, getProjectGallaryFail, deleteProjectGalleryFail, deleteProjectGallerySuccess, getSearchAllProjectSuccess, updateProjectStatusSuccess, updateProjectStatusError, deleteProjectFeatureSuccess, deleteProjectFeatureFail, addProjectBudgeAllocationSuccess, getProjectBudgeAllocationSuccess, addProjectBudgeAllocationFail, getProjectBudgeAllocationFail, updateProjectBudgeAllocationFail, deleteProjectBudgeAllocationSuccess, deleteProjectBudgeAllocationFail, addProjectBudgeSpentSuccess, getProjectBudgeSpentSuccess, addProjectBudgeSpentFail, getProjectBudgeSpentFail, deleteProjectBudgeSpentSuccess, deleteProjectBudgeSpentFail, updateProjectBudgeSpentFail, addProjectCampLeadSuccess, addProjectCampLeadFail, getProjectCampLead, getProjectCampLeadSuccess, getProjectCampLeadFail, deleteProjectCampLeadSuccess, deleteProjectCampLeadFail, getProjectFeatureStandardSuccess, getProjectFeatureStandardFail, updateProjectFeatureStandardSuccess, updateProjectFeatureStandardFail, addProjectEmailCampFilterSuccess, addProjectEmailCampFilterFail, addProjectSettingWorksheetSuccess, addProjectSettingWorksheetFail, getProjectSettingWorksheetSuccess, getProjectSettingWorksheetFail, deleteProjectSettingWorksheetSuccess, deleteProjectSettingWorksheetFail, sendProjectLeadWorksheetSuccess, sendProjectLeadWorksheetFail, getAllProjectLeadSuccess, getAllProjectLeadFail, getAllProjectClientSuccess, getAllProjectClientFail, addProjectOpenHouseFile,addProjectOpenHouseFileSuccess,addProjectOpenHouseFileError , addProjectOpenHouseSuccess,addProjectOpenHouseError,getAllProjectOpenHouseSuccess,getAllProjectOpenHouseError,getProjectOpenHouseSuccess,getProjectOpenHouseError,deleteProjectOpenHouseSuccess,deleteProjectOpenHouseError,updateProjectOpenHouseSuccess,updateProjectOpenHouseError,addProjectDownloadPriceFileSuccess,addProjectDownloadPriceFileError , addProjectDownloadPriceSuccess,addProjectDownloadPriceError,getAllProjectDownloadPriceSuccess,getAllProjectDownloadPriceError,getProjectDownloadPriceSuccess,getProjectDownloadPriceError,deleteProjectDownloadPriceSuccess,deleteProjectDownloadPriceError,updateProjectDownloadPriceSuccess,updateProjectDownloadPriceError,getAllProjectOpenHouseFileSuccess,getAllProjectOpenHouseFileError, getProjectOpenHouseFilesSuccess, getProjectOpenHouseFilesFail, deleteProjectOpenHouseFileSuccess, deleteProjectOpenHouseFile, deleteProjectOpenHouseFileError, getProjectDownloadPriceFilesSuccess, getProjectDownloadPriceFilesFail, deleteProjectDownloadPriceFileError, deleteProjectDownloadPriceFileSuccess, getProjectWorksheetLeadSuccess, getProjectWorksheetLeadFail, getProjectWorksheetLeadPurDetailSuccess, getProjectWorksheetLeadUnitDetailSuccess, getProjectWorksheetLeadUnitDetailFail, getProjectWorksheetLeadPurDetailFail, getProjectWorksheetLeadDocDetailSuccess, getProjectWorksheetLeadDocDetailFail, addProjectInviteSuccess, getProjectInviteSuccess, addProjectInviteError, getProjectInviteError, deleteProjectInviteSuccess, deleteProjectInviteError, getProjectInviteAttSuccess, getProjectInviteAttError, updateProjectLinkFail, updateProjectWorksheetUnitError, getProjectWorksheetUnitinfoSuccess, getProjectWorksheetUnitinfoFail, getProjectLeadByWorsheetStatusSuccess, getProjectLeadByWorsheetStatusFail, getProjectInviteDetailSuccess, getProjectInviteDetailError, updateProjectInviteError, getAllProjectLandingPagesSuccess, getAllProjectLandingPagesFail, addOpenhouseFormSuccess, getOpenhouseFormSuccess, addOpenhouseFormError, getOpenhouseFormError, } from "./actions"
import { deleteProject, deleteProjectCampLeadApi, deleteProjectContactAPI, deleteProjectDocumentAPI, deleteProjectFeatApi, deleteProjectGalleryApi, deleteProjectLinkApi, deleteProjectMarketAllocationApi, deleteProjectMarketApi, deleteProjectMarketSpentApi, deleteProjectSettingWorksheetApi, getAllProjectClientApi, getAllProjectLeadPagedApi, normalizeLeadPagedResponse, getAllProjectSearchApi, getProject, getProjectByUID, getProjectCampLeadApi, getProjectContactApi, getProjectDocumentApi, getProjectFeatApi, getProjectFeatStandardApi, getProjectGalleryApi, getProjectLinkApi, getProjectMarketAllocationApi, getProjectMarketApi, getProjectMarketSpentApi, getProjectSettingWorksheetApi, postProject, postProjectCampLead, postProjectContactApi, postProjectDocumentApi, postProjectEmailCampFilterAPI, postProjectFeatApi, postProjectGalleryApi, postProjectLeadWorksheetApi, postProjectLinkApi, postProjectMarketAllocationApi, postProjectMarketApi, postProjectMarketSpentApi, postProjectSettingWorksheetApi, updateProject, updateProjectContactAPI, updateProjectFeatApi, updateProjectFeatStandardApi, updateProjectMarketAllocationApi, updateProjectMarketApi, updateProjectMarketSpentApi, updatemProjectStatusAPI,postProjectOpenHouseFile,postProjectOpenHouse,getAllProjectOpenHouseFileApi,getAllProjectOpenHouseApi,getProjectOpenHouseApi,deleteProjectOpenHouseApi,updateProjectOpenHouseApi,postProjectDownloadPriceFile,postProjectDownloadPrice,getAllProjectDownloadPriceApi,getProjectDownloadPriceApi,deleteProjectDownloadPriceApi,updateProjectDownloadPriceApi, getProjectOpenHouseFile, deleteProjectOpenHouseFileUrl, getProjectDPFile, deleteProjectDPeUrl, getProjectWorksheetLeadApi, getProjectWorksheetPurApi, getProjectWorksheetUnitApi, getProjectWorksheetDocApi, postProjectEventInviteAPI, getProjectEventInviteAPI, deleteProjectEventInviteAPI, getProjectInviteAttAPI, updateProjectLinkApi, updatemProjectWorksheetUnitAPI, getWorksheetUnitInfoAPI, getProjectLeadByWorksheetStatusAPI, getProjectEventInviteDetailAPI, updateProjectEventInviteAPI, getAllProjectLandingPageApi, postProjectOpenhouseFormAPI, getProjectOpenhouseFormAPI } from "../../helpers/backend_helper"
import { DELETE_PROJECT_STATUS, UPDATE_PROJECT_STATUS } from "store/settings/Appointment/actionTypes";


function* createProject({ payload: { project, callback } }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(postProject, {
      projectName: project.projectName,
      projectBuilder: parseInt(project.projectBuilder),
      projectType: parseInt(project.projectType),
      complitionMonth: project.complitionMonth,
      complitionYear: parseInt(project.complitionYear),
      minPriceRange: parseInt(project.minPriceRange),
      maxPriceRange: parseInt(project.maxPriceRange),
      costPerSqFt: parseInt(project.costPerSqFt),
      noOfUnits: project.noOfUnits,
      noOfStories: project.noOfStories,
      minBed: project.minBed,
      maxBed: project.maxBed,
      minArea: parseInt(project.minArea),
      maxArea: parseInt(project.maxArea),
      city: project.city,
      agentWebSite: project.agentWebSite,
      agentId: parseInt(localStorage.getItem("userId")),
      commision: parseInt(project.commision),
      projectStatus: parseInt(project.projectStatus),
      estimatedOccupancy: project.estimatedOccupancy,
      vipLaunchDate: project.vipLaunchDate,
      publicLaunchDate: project.publicLaunchDate,
      projectNearestIntersection:project.projectNearestIntersection,
      isPublished:false,
      projectLogoLink:project.projectLogoLink,
      fullAddress:project.fullAddress,
      addressLine1:project.addressLine1,
      addressLine2:project.addressLine2,
      province:project.province,
      postal:project.postal,
      country:project.country,
      longitude:project.longitude,
      latitude:project.latitude,
      projectCurrencyCode:project.projectCurrencyCode

    })

    yield put(addProjectSuccess(response))
    if (response.success) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const response = yield call(getProject, localStorage.getItem('userId'), localStorage.getItem('brokerId'))
      yield put(getAllProjectActionSuccess(response))
      if(callback) { callback(true);}
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
       if(callback) { callback(false);}
    }
  } catch (error) {
    yield put(addProjectError(error))
     if(callback) { callback(false);}
  }
}

function* fetchAllProject({ payload: { agentId, brokerId, archiveStatus } }) {
  try {
    const response = yield call(getProject, agentId, brokerId, archiveStatus)
    yield put(getAllProjectActionSuccess(response))
  } catch (error) {
    yield put(getAllProjectActionFail(error))
  }
}

function* createProjectFeature({ payload: { feature, history } }) {

  try {
    toast.loading("Please wait...")


    const response = yield call(postProjectFeatApi, {
      projectId: parseInt(feature.projectId),
      agentId: parseInt(localStorage.getItem("userId")),
      projectGuid: feature.projectGuid,
      projectAdditionalFeatureTitle: feature.projectAdditionalFeatureTitle,
      projectAdditionalFeatureDescription: feature.projectAdditionalFeatureDescription,
      isStandardFeature:false
    })

    yield put(addProjectFeatureSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = localStorage.getItem("userId");
      const res = yield call(getProjectFeatStandardApi, feature.projectGuid, agentId)
      yield put(getProjectFeatureStandardSuccess(res))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  } catch (error) {
    yield put(addProjectFeatureFail(error))
  }
}


function* createProjectContact({ payload: { contact, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postProjectContactApi, {
      projectId: parseInt(contact.projectId),
      agentId: parseInt(localStorage.getItem("userId")),
      projectGuid: contact.projectGuid,
      pContactDepartment: contact.pContactDepartment,
      pContactName: contact.pContactName,
      pContactIsActive: true,
      phone: contact.contactPhone,
      phoneExt: contact.phoneExt,
      email: contact.emailContact,
      mobile: contact.contactMobile,
      fax: contact.contactFax,
    });
    yield put(addProjectContactSuccess(response));
    if (response.success) {
      toast.update(toastId, {
        render: "Saved successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
       const agentId = parseInt(localStorage.getItem("userId"))
      const res = yield call(getProjectContactApi, contact.projectGuid, agentId);
      yield put(getProjectContactSuccess(res));
      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some issue occurred",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "Failed to add project contact",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });

    yield put(addProjectContactFail(error));

    if (callback) callback(false);
  }
}

function* fetchProjectContact({ projectId }) {
  try {
    const agentId = parseInt(localStorage.getItem("userId"))
    const response = yield call(getProjectContactApi, projectId, agentId)
    yield put(getProjectContactSuccess(response))
  } catch (error) {
    yield put(getProjectContactFail(error))
  }
}


function* submitProjectDocument({ payload: { document, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectDocumentApi, {
      agentId: parseInt(localStorage.getItem("userId")),
      projectDocumentTitle: document.projectDocumentTitle,
      projectDocumentLink: document.projectDocumentLink,
      projectDocumentContent: document.projectDocumentContent,
      projectDocumentTypeId: parseInt(document.projectDocumentTypeId),
      agentId: parseInt(document.agentId),
      projectId: parseInt(document.projectId),
      projectGuid:document.projectGuid

    })
    yield put(addProjectMediaSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = localStorage.getItem("userId");
      const response = yield call(getProjectDocumentApi,document.projectGuid, agentId)
      yield put(getProjectMediaSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectMediaFail(error))
  }
}

function* fetchProjectDocument({ projectId }) {
  try {
    const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectDocumentApi, projectId, agentId)
    yield put(getProjectMediaSuccess(response))
  } catch (error) {
    yield put(getProjectMediaFail(error))
  }
}


function* submitProjectMarket({ payload: { market, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectMarketApi, {

      platform: market.platform,
      agentId: localStorage.getItem("userId"),
      allocatedBudget: parseInt(market.allocatedBudget),
      alreadySpent: parseInt(market.alreadySpent),
      projectId: parseInt(market.projectId)

    })
    yield put(addProjectMarketSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = localStorage.getItem("userId");
      const response = yield call(getProjectMarketApi, parseInt(parseInt(market.projectId)), agentId)
      yield put(getProjectMarketSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectMarketFail(error))
  }
}
function* fetchProjectMarket({ projectId }) {
  try {
    const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectMarketApi, projectId, agentId)
    yield put(getProjectMarketSuccess(response))
  } catch (error) {
    yield put(getProjectMarketFail(error))
  }
}

function* fetchProjectTab1({ uuid }) {
  try {
    //
    const response = yield call(getProjectByUID, uuid)
    yield put(getProjectUUIDActionSuccess(response))
  } catch (error) {
    yield put(getProjectUUIDActionFail(error))
  }
}

function* fetchFeatureTab({ projectId }) {
  try {
    //
    const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectFeatApi, projectId, agentId)
    yield put(getProjectFeatureActionSuccess(response))
  } catch (error) {
    yield put(getProjectFeatureActionFail(error))
  }
}


function* onDeleteProject({ payload: project }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteProject, project)
    yield put(deleteProjectSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getProject, localStorage.getItem('userId'),2)
    yield put(getAllProjectActionSuccess(res))
  } catch (error) {
    yield put(deleteProjectFail(error))
  }
}

function* onUpdateProject({ payload:  project  }) {

  try {
    toast.loading("Please wait...")
    const response = yield call(updateProject, project)
    const res = yield call(getProjectByUID, project.projectId)
    yield put(getProjectUUIDActionSuccess(res))
    if(response.success==true){
    toast.dismiss();
    toast.success("Updated successfully.");
    }else{
      toast.dismiss();
      toast.warning(response.validationErrors[0]);
    }
  } catch (error) {
    yield put(projectUpdateError(error))
  }
}

function* onUpdateProjectFeature({ payload:  projectFeature  }) {
  //
  try {
    toast.loading("Please wait...")
    //
    const response = yield call(updateProjectFeatApi, projectFeature)
    yield put(updateProjectFeatureSuccess(response))
    toast.dismiss();
    toast.success("Updated successfully.");
    const agentId = localStorage.getItem("userId");
    const res = yield call(getProjectFeatStandardApi, projectFeature.projectId, agentId)
    yield put(getProjectFeatureStandardSuccess(res))
  } catch (error) {
    yield put(updateProjectFeatureFail(error))
  }
}

function* onProjectContactUpdate({ payload: { contact, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateProjectContactAPI, contact);

    if(response.success){
      const agentId = localStorage.getItem("userId");
      const res = yield call(getProjectContactApi, contact.projectGuid, agentId);
      yield put(getProjectContactSuccess(res));
      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback) callback(true);
  }else{
     toast.update(toastId, {
        render: response.validationErrors?.[0] || "Failed to update contact",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback) callback(false);
  }
  } catch (error) {
    // Update toast with error message
    toast.update(toastId, {
      render: "Failed to update contact",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    yield put(updateProjectContactFail(error));
    if (callback) callback(false);
  }
}


function* onProjectLinkUpdate({ payload: { link, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateProjectLinkApi, link);
    if (response?.success) {
      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    const agentId = parseInt(localStorage.getItem("userId"));
    const res = yield call(getProjectLinkApi, link.projectGuid, agentId);
      yield put(getProjectLinkSuccess(res));
      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response?.validationErrors?.[0] || "Update failed",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
       if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
     if (callback) callback(false);
    yield put(updateProjectLinkFail(error));
  }
}

function* onDeleteContact({ payload: contact }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectContactAPI, contact.projectContactId)
    yield put(deleteProjectContactSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectContactApi, contact.projectGuid, agentId)
    yield put(getProjectContactSuccess(res))
  } catch (error) {
    yield put(deleteProjectContactFail(error))
  }
}



function* onDeleteDocument({ payload: document }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectDocumentAPI, document.projectDocumentId)
    yield put(deleteProjectDocumentSuccess(response))
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectDocumentApi, document.projectGuid, agentId)
    yield put(getProjectMediaSuccess(res))
    toast.dismiss();
  } catch (error) {
    yield put(deleteProjectDocumentFail(error))
  }
}

function* onProjectMarketUpdate({ payload: market }) {
  //
  try {
    //toast.loading("Please wait...")
    const response = yield call(updateProjectMarketApi, market)
    if (response.success == true) {
      
      const agentId = parseInt(localStorage.getItem("userId"))
      const res = yield call(getProjectMarketApi, parseInt(parseInt(market.projectId)), agentId)
      yield put(getProjectMarketSuccess(res))
    }
    //yield put(updateProjectMarketSuccess(response))
    
  } catch (error) {
    yield put(updateProjectMarketFail(error))
  }
}

function* onDeleteMarket({ payload: market }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectMarketApi, market.id)
    yield put(deleteProjectMarketSuccess(response))
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectMarketApi, market.projectId, agentId)
    yield put(getProjectMarketSuccess(res))
    toast.dismiss();
  } catch (error) {
    yield put(deleteProjectMarketFail(error))
  }
}

function* submitProjectLink({ payload: { link, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postProjectLinkApi, link);
    yield put(addProjectLinkSuccess(response));
    if (response?.success) {
      toast.update(toastId, {
        render: "Saved successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      const agentId = parseInt(localStorage.getItem("userId"))
      const linksResponse = yield call(getProjectLinkApi, link.projectGuid, agentId);
      yield put(getProjectLinkSuccess(linksResponse));
      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some Error. Please try after some time",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
       if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "Something went wrong. Please try later",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    yield put(addProjectLinkFail(error));
    if (callback) callback(false);
  }
}


function* fetchProjectLink({ projectId }) {
  try {
    //
    const agentId = parseInt(localStorage.getItem("userId"))
    const response = yield call(getProjectLinkApi, projectId, agentId)
    yield put(getProjectLinkSuccess(response))
  } catch (error) {
    yield put(getProjectLinkFail(error))
  }
}

function* onDeleteLink({ payload: link }) {
  try {
   
    toast.loading("Please wait...")
    const response = yield call(deleteProjectLinkApi, link.projectLinkId)
    yield put(deleteProjectLinkSuccess(response))
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectLinkApi, link.projectGuid, agentId)
    yield put(getProjectLinkSuccess(res))
    toast.dismiss();
    toast.success('Deleted successfully.')
  } catch (error) {
    yield put(deleteProjectLinkFail(error))
  }
}

function* submitProjectGallery({ payload: { gallery, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectGalleryApi,gallery)
    yield put(addProjectGallerySuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = parseInt(localStorage.getItem("userId"))
      const response = yield call(getProjectGalleryApi, gallery.projectGuid, gallery.projectGalleryTypeId, agentId)
      yield put(getProjectGallarySuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectGalleryFail(error))
  }
}

function* fetchProjectGallery({ payload: { projectId, typeId }}) {
  try {
    //
    const agentId = parseInt(localStorage.getItem("userId"))
    const response = yield call(getProjectGalleryApi, projectId, typeId, agentId)
    yield put(getProjectGallarySuccess(response))
  } catch (error) {
    yield put(getProjectGallaryFail(error))
  }
}

function* onDeleteGallery({ payload: image }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectGalleryApi, image.projectGalleryId)
    yield put(deleteProjectGallerySuccess(response))
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectGalleryApi, image.projectGuid, image.projectGalleryTypeId, agentId)
    yield put(getProjectGallarySuccess(res))
    toast.dismiss();
  } catch (error) {
    yield put(deleteProjectGalleryFail(error))
  }
}

function* searchProjectAsync({payload: {searchProjectQuery}}) {
  try {
    //
    const response = yield call(getAllProjectSearchApi,searchProjectQuery)
    yield put(getSearchAllProjectSuccess(response))
  } catch (error) {
   
  }
}


function* onUpdateProjectStatus({ payload:  project  }) {

  try {
    toast.loading("Please wait...")
    const response = yield call(updatemProjectStatusAPI, project)
    //yield put(updateProjectStatusSuccess(response))
   
    toast.dismiss();
    toast.success("Updated successfully.");
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProject, agentId, 2)
    yield put(getAllProjectActionSuccess(res))
  } catch (error) {
    yield put(updateProjectStatusError(error))
  }
}

function* onDeleteFeature({ payload: projectFeature }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectFeatApi, projectFeature.id)
    yield put(deleteProjectFeatureSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
   const agentId = localStorage.getItem("userId");
    const res = yield call(getProjectFeatStandardApi, projectFeature.projectId, agentId)
    yield put(getProjectFeatureStandardSuccess(res))
    
  } catch (error) {
    yield put(deleteProjectFeatureFail(error))
  }
}

function* submitProjectMarketAllocation({ payload: { budget, history } }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectMarketAllocationApi, {

      projectId: parseInt(budget.projectId),
      platform: budget.platform,
      projectGuid:budget.projectGuid,
      allocatedBudget: parseInt(budget.allocatedBudget),
      

    })
    yield put(addProjectBudgeAllocationSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = parseInt(localStorage.getItem("userId"))
      const response = yield call(getProjectMarketAllocationApi, budget.projectGuid, agentId)
      yield put(getProjectBudgeAllocationSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectBudgeAllocationFail(error))
  }
}

function* fetchProjectMarketAllocation({ projectId }) {
  try {
    //
     const agentId = parseInt(localStorage.getItem("userId"))
    const response = yield call(getProjectMarketAllocationApi, projectId, agentId)
    yield put(getProjectBudgeAllocationSuccess(response))
  } catch (error) {
    yield put(getProjectBudgeAllocationFail(error))
  }
}

function* onUpdateProjectMarketAllocation({ payload:  allocation  }) {
//
  try {
    toast.loading("Please wait...")
    const response = yield call(updateProjectMarketAllocationApi, allocation)
    
   
    toast.dismiss();
    toast.success("Updated successfully.");
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectMarketAllocationApi, allocation.projectGuid, agentId)
    yield put(getProjectBudgeAllocationSuccess(res))
  } catch (error) {
    yield put(updateProjectBudgeAllocationFail(error))
  }
}

function* onDeleteProjectMarketAllocation({ payload: allocation }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectMarketAllocationApi, allocation.projectMarketingAllocationId)
    yield put(deleteProjectBudgeAllocationSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectMarketAllocationApi, allocation.projectGuid, agentId)
    yield put(getProjectBudgeAllocationSuccess(res))
    
  } catch (error) {
    yield put(deleteProjectBudgeAllocationFail(error))
  }
}

function* submitProjectMarketSpent({ payload: { spent, history } }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectMarketSpentApi, {

      projectId: parseInt(spent.projectId),
      platform: spent.platform,
      projectGuid:spent.projectGuid,
      alreadySpent: parseInt(spent.alreadySpent),
      

    })
    yield put(addProjectBudgeSpentSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = parseInt(localStorage.getItem("userId"))
      const response = yield call(getProjectMarketSpentApi, spent.projectGuid, agentId)
      yield put(getProjectBudgeSpentSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectBudgeSpentFail(error))
  }
}

function* fetchProjectMarketSpent({ projectId }) {
  try {
     const agentId = parseInt(localStorage.getItem("userId"))
    const response = yield call(getProjectMarketSpentApi, projectId, agentId)
    yield put(getProjectBudgeSpentSuccess(response))
  } catch (error) {
    yield put(getProjectBudgeSpentFail(error))
  }
}

function* onDeleteProjectMarketSpent({ payload: spent }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectMarketSpentApi, spent.projectMarketingSpentId)
    yield put(deleteProjectBudgeSpentSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
      const agentId = parseInt(localStorage.getItem("userId"))
    const res = yield call(getProjectMarketSpentApi, spent.projectGuid, agentId)
    yield put(getProjectBudgeSpentSuccess(res))
    
  } catch (error) {
    yield put(deleteProjectBudgeSpentFail(error))
  }
}

function* onUpdateProjectMarketSpent({ payload:  spent  }) {
  //
    try {
      toast.loading("Please wait...")
      const response = yield call(updateProjectMarketSpentApi, spent)
      
     
      toast.dismiss();
      toast.success("Updated successfully.");
        const agentId = parseInt(localStorage.getItem("userId"))
      const res = yield call(getProjectMarketSpentApi, spent.projectGuid, agentId)
      yield put(getProjectBudgeSpentSuccess(res))
    } catch (error) {
      yield put(updateProjectBudgeSpentFail(error))
    }
  }


  function* submitProjectCampLead({ payload: { lead, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postProjectCampLead, {
      projectCampaignId: parseInt(lead.projectCampaignId),
      campaignProjectId: parseInt(lead.projectCampaignId),
      projectCampaignGuid: lead.projectCampaignGuid,
      campaignProjectGuid: lead.campaignProjectGuid,
      firstName: lead.firstName,
      lastName: lead.lastName,
      email: lead.email,
      phone: lead.phone,
      leadStatusId: 0,
      leadTypeId: 0,
      leadSourceId: lead.leadSourceId ? parseInt(lead.leadSourceId) : 0,
      //leadSourceText: lead.leadSourceText,
      referedByContactId: parseInt(lead.referedByContactId),
      phoneExt: '',
      mobile: lead.mobile,
      fullAddress: lead.fullAddress,
      addressLine1: lead.addressLine1,
      addressLine2: lead.addressLine2,
      nearestIntersection: lead.nearestIntersection,
      city: lead.city,
      province: lead.province,
      postal: lead.postal,
      country: lead.country,
      longitude: lead.longitude,
      latitude: lead.latitude,
      agentId: parseInt(localStorage.getItem("userId")),
      notes: '',
      isActive: true
    });

    yield put(addProjectCampLeadSuccess(response));

    if (response.success === true) {
      
      const res = yield call(getProjectCampLeadApi, localStorage.getItem("userId"), lead.campaignProjectGuid);
      yield put(getProjectCampLeadSuccess(res));
      toast.update(toastId, {
        render: "Saved successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000
      });

      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some issue occurred",
        type: "warning",
        isLoading: false,
        autoClose: 3000
      });

      if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "Failed to add project lead",
      type: "error",
      isLoading: false,
      autoClose: 3000
    });

    if (callback) callback(false);
    yield put(addProjectCampLeadFail(error));
  }
}


  function* fetchProjectCampLead({ payload: { agentId, projectId }}) {
    try {
     
      const response = yield call(getProjectCampLeadApi, agentId, projectId)
      yield put(getProjectCampLeadSuccess(response))
    } catch (error) {
      yield put(getProjectCampLeadFail(error))
    }
  }  

  function* onDeleteProjectCampLead({ payload: camplead }) {
    try {
      //
      toast.loading("Please wait...")
      const response = yield call(deleteProjectCampLeadApi, camplead.projectCampaignLeadId)
      yield put(deleteProjectCampLeadSuccess(response))
      toast.dismiss();
      toast.success("Deleted successfully.");
      const res = yield call(getProjectCampLeadApi, camplead.agentId, camplead?.project.projectGuid)
      yield put(getProjectCampLeadSuccess(res))

    } catch (error) {
      toast.dismiss();
      toast.error("Couldn't delete this lead. Please try again.");
      yield put(deleteProjectCampLeadFail(error))
    }
  }

  function* fetchFeatureStatandardTab({ projectId }) {
    try {
      //
      const agentId = localStorage.getItem("userId");
      const response = yield call(getProjectFeatStandardApi, projectId, agentId)
      yield put(getProjectFeatureStandardSuccess(response))
    } catch (error) {
      yield put(getProjectFeatureStandardFail(error))
    }
  }

function* onUpdateProjectFeatureStandard({ payload: { projectStandardFeature, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateProjectFeatStandardApi, projectStandardFeature);
     yield put(updateProjectFeatureStandardSuccess(response));
    if (response?.success) {
       toast.update(toastId, { render: "Updated successfully.", type: "success", isLoading: false, autoClose: 3000 });
       const agentId = localStorage.getItem("userId");
        const res = yield call(getProjectFeatStandardApi, projectStandardFeature.projectGuid, agentId);
        yield put(getProjectFeatureStandardSuccess(res));

    if (callback) callback(true);
    }else{
          toast.update(toastId, { render: response.validationErrors?.[0] || "Update failed", type: "warning", isLoading: false });
      if (callback) callback(false);
    }
    
  } catch (error) {
    toast.update(toastId, { render: "Failed to update", type: "error", isLoading: false });
    yield put(updateProjectFeatureStandardFail(error));
     if (callback) callback(false);
  }
}


  function* submitProjectEmailFilter({ payload: { emailFilter, history } }) {
    //
    try {
      toast.loading("Please wait...")
      const response = yield call(postProjectEmailCampFilterAPI,emailFilter)
      yield put(addProjectEmailCampFilterSuccess(response))
      if (response.success == true) {
        
      } else {
        toast.warn("Some Error. Please try after some time");
      }
    }
    catch (error) {
  
      yield put(addProjectEmailCampFilterFail(error))
    }
  }

  function* submitProjectSettingWorksheet({ payload: { worksheet, history } }) {
    try {
      toast.loading("Please wait...")
      const response = yield call(postProjectSettingWorksheetApi, {
  
        projectWorkSheetTitle: worksheet.projectWorkSheetTitle,
        projectWorkSheetLink: worksheet.projectWorkSheetLink,
        projectWorkSheetContent: worksheet.projectWorkSheetContent,
        documentStorageType: parseInt(worksheet.documentStorageType),
        agentId: parseInt(worksheet.agentId),
        projectId: parseInt(worksheet.projectId),
        builderId:0,
        isActive:true,
        addedOn:worksheet.addedOn,
        emailCampaignTitle: worksheet.projectWorkSheetTitle,
        emailCampaignSubject: worksheet.subject,
        emailCampaignContent: worksheet.projectAdditionalFeatureDescription
  
      })
      yield put(addProjectSettingWorksheetSuccess(response))
      if (response.success == true) {
        toast.dismiss();
        toast.success("Saved successfully.");
        const response = yield call(getProjectSettingWorksheetApi, worksheet.projectId)
        yield put(getProjectSettingWorksheetSuccess(response))
      } else {
        toast.warn("Some Error. Please try after some time");
      }
    }
    catch (error) {
  
      yield put(addProjectSettingWorksheetFail(error))
    }
  }
  
  function* fetchProjectSettingWorksheet({ projectId }) {
    try {
      //
      const response = yield call(getProjectSettingWorksheetApi, projectId)
      yield put(getProjectSettingWorksheetSuccess(response))
    } catch (error) {
      yield put(getProjectSettingWorksheetFail(error))
    }
  }

  function* onDeleteProjectSettingWorksheet({ payload: worksheet }) {
    try {
      //
      toast.loading("Please wait...")
      const response = yield call(deleteProjectSettingWorksheetApi, worksheet.id)
      yield put(deleteProjectSettingWorksheetSuccess(response))
      toast.dismiss();
      toast.success("Worksheet Deleted");
      const res = yield call(getProjectSettingWorksheetApi, worksheet.projectId)
      yield put(getProjectSettingWorksheetSuccess(res))
      
    } catch (error) {
      yield put(deleteProjectSettingWorksheetFail(error))
    }
  }

  function* submitProjectLeadWorksheet({ payload: { leadworksheet, history } }) {
    try {
      toast.loading("Please wait...")
      const response = yield call(postProjectLeadWorksheetApi, leadworksheet)
      yield put(sendProjectLeadWorksheetSuccess(response))
      if (response.success == true) {
        toast.dismiss();
        toast.success("Saved successfully.");
       
      } else {
        toast.warn("Some Error. Please try after some time");
      }
    }
    catch (error) {
  
      yield put(sendProjectLeadWorksheetFail(error))
    }
  }

  function* fetchAllProjectLead(action) {
    try {
      const { agentId, pageNumber, pageSize, sortBy, sortDirection, filterColumns, filterValues } = action
      const explicitPagination = pageNumber != null || pageSize != null
      const body = {
        agentId: parseInt(agentId, 10),
        pageNumber: explicitPagination ? pageNumber ?? 1 : 1,
        pageSize: explicitPagination ? pageSize ?? 10 : 10000,
        sortBy: sortBy ?? "",
        sortDirection: sortDirection ?? "",
        filterColumns: filterColumns ?? [],
        filterValues: filterValues ?? [],
      }
      const response = yield call(getAllProjectLeadPagedApi, body)
      const { items, totalCount } = normalizeLeadPagedResponse(response)
      yield put(
        getAllProjectLeadSuccess({
          items,
          totalCount,
          query: {
            pageNumber: body.pageNumber,
            pageSize: body.pageSize,
          },
        })
      )
    } catch (error) {
      yield put(getAllProjectLeadFail(error))
    }
  }

  function* fetchAllProjectClient({ agentId }) {
    try {
      //
      const response = yield call(getAllProjectClientApi, agentId)
      yield put(getAllProjectClientSuccess(response))
    } catch (error) {
      yield put(getAllProjectClientFail(error))
    }
  }


  
//ProjectOpenHouse
  function* createProjectOpenHouseFile({ payload: { data, history } }) {
    //
    try {
      toast.loading("Please wait...")
      const response = yield call(postProjectOpenHouseFile, data)
  
      yield put(addProjectOpenHouseFileSuccess(response))
      if (response.success == true) {
        const data = JSON.stringify(response.project);
        const pr = JSON.parse(data);
        toast.dismiss();
        toast.success("Saved successfully.");
        // history.push("/pre-construction/create-project/feature/" + pr.id + "/" + pr.projectId)
      } else {
        toast.dismiss();
        toast.warn(response.validationErrors[0]);
      }
    } catch (error) {
      yield put(addProjectOpenHouseFileError(error))
    }
  }

  function* fetchAllProjectOpenHouseFile() {
    try {
      const response = yield call(getAllProjectOpenHouseFileApi)
      yield put(getAllProjectOpenHouseFileSuccess(response))
    } catch (error) {
      yield put(getAllProjectOpenHouseFileError(error))
    }
  }

  function* createProjectOpenHouse({ payload: { data } }) {
    //
    try {
      toast.loading("Please wait...")
      const response = yield call(postProjectOpenHouse, data)
  
      yield put(addProjectOpenHouseSuccess(response))
      if (response.success == true) {
        const data = JSON.stringify(response.projectOpenHouse);
        const pr = JSON.parse(data);
        toast.dismiss();
        toast.success("Saved successfully.");
        const res = yield call(getAllProjectOpenHouseApi)
      yield put(getAllProjectOpenHouseSuccess(res))
        // history.push("/pre-construction/create-project/feature/" + pr.id + "/" + pr.projectId)
      } else {
        toast.dismiss();
        toast.warn(response.validationErrors[0]);
      }
    } catch (error) {
      yield put(addProjectOpenHouseError(error))
      
        toast.success("Error Open House Field is Added");
        toast.dismiss();
    }
  }

  function* fetchAllProjectOpenHouse({payload: {agentId, projectId}}) {
    try {
      const response = yield call(getAllProjectOpenHouseApi, agentId, projectId)
      yield put(getAllProjectOpenHouseSuccess(response))
    } catch (error) {
      yield put(getAllProjectOpenHouseError(error))
    }
  }

  function* fetchProjectOpenHouse( { id } ) {
    try {
      const response = yield call(getProjectOpenHouseApi,id)
      yield put(getProjectOpenHouseSuccess(response))
    } catch (error) {
      yield put(getAllProjectOpenHouseError(error))
    }
  }

  function* onDeleteProjectOpenHouse({ payload: id }) {
    try {
      //
      toast.loading("Please wait...")
      const response = yield call(deleteProjectOpenHouseApi, id.id)
      yield put(deleteProjectOpenHouseSuccess(response))
      toast.dismiss();
      toast.success("Deleted successfully.");
      const res = yield call(getAllProjectOpenHouseApi, id.agentId, id.campaignProjectId)
      yield put(getAllProjectOpenHouseSuccess(res))
      
    } catch (error) {
      yield put(deleteProjectOpenHouseError(error))
    }
  }

function* onUpdateProjectOpenHouse({ payload: { data, callback } }) {
  
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateProjectOpenHouseApi, data);
    yield put(updateProjectOpenHouseSuccess(response));
    if(response.success){
    toast.update(toastId, {
      render: "Updated successfully.",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    const res = yield call(
      getProjectCampLeadApi,
      localStorage.getItem("userId"),
      data.campaignProjectGuid
    );
    yield put(getProjectCampLeadSuccess(res));
     if (callback) callback(true);
  }else{
       toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some issue occurred",
        type: "warning",
        isLoading: false,
        autoClose: 3000
      });
      if (callback) callback(false);

  }

  } catch (error) {
    toast.update(toastId, {
      render: "Update failed. Please try again.",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
     if (callback) callback(false);
    yield put(updateProjectOpenHouseError(error));
  }
}


  
  
//ProjectDownloadPrice
function* createProjectDownloadPriceFile({ payload: { data, history } }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectDownloadPriceFile, data)

    yield put(addProjectDownloadPriceFileSuccess(response))
    if (response.success == true) {
      const data = JSON.stringify(response.project);
      const pr = JSON.parse(data);
      toast.dismiss();
      toast.success("Saved successfully.");
      // history.push("/pre-construction/create-project/feature/" + pr.id + "/" + pr.projectId)
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  } catch (error) {
    yield put(addProjectDownloadPriceFileError(error))
  }
}

function* createProjectDownloadPrice({ payload: { data } }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectDownloadPrice, data)

    yield put(addProjectDownloadPriceSuccess(response))
    if (response.success == true) {
      const data = JSON.stringify(response.projectOpenHouse);
      const pr = JSON.parse(data);
      toast.dismiss();
      toast.success("Saved successfully.");
      const res = yield call(getAllProjectDownloadPriceApi)
    yield put(getAllProjectDownloadPriceSuccess(res))
      // history.push("/pre-construction/create-project/feature/" + pr.id + "/" + pr.projectId)
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  } catch (error) {
    yield put(addProjectDownloadPriceError(error))
    
      toast.success("Error in Download Price Field ");
      toast.dismiss();
  }
}

function* fetchAllProjectDownloadPrice() {
  try {
    const response = yield call(getAllProjectDownloadPriceApi)
    yield put(getAllProjectDownloadPriceSuccess(response))
  } catch (error) {
    yield put(getAllProjectDownloadPriceError(error))
  }
}

function* fetchProjectDownloadPrice( { id } ) {
  try {
    const response = yield call(getProjectDownloadPriceApi,id)
    yield put(getProjectDownloadPriceSuccess(response))
  } catch (error) {
    yield put(getAllProjectDownloadPriceError(error))
  }
}

function* onDeleteProjectDownloadPrice({ payload: id }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(deleteProjectDownloadPriceApi, id)
    yield put(deleteProjectDownloadPriceSuccess(response))
    toast.dismiss();
    toast.success(" Deleted successfully.");
    const res = yield call(getAllProjectDownloadPriceApi)
    yield put(getAllProjectDownloadPriceSuccess(res))
    
  } catch (error) {
    yield put(deleteProjectDownloadPriceError(error))
  }
}

function* onUpdateProjectDownloadPrice({ payload: { data } }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(updateProjectDownloadPriceApi, data)

    yield put(updateProjectDownloadPriceSuccess(response))
    if (response.success == true) {
      const data = JSON.stringify(response.projectOpenHouse);
      const pr = JSON.parse(data);
      toast.dismiss();
      toast.success("Updated successfully.");
      const res = yield call(getAllProjectDownloadPriceApi)
    yield put(getAllProjectDownloadPriceSuccess(res))
      // history.push("/pre-construction/create-project/feature/" + pr.id + "/" + pr.projectId)
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  } catch (error) {
    yield put(updateProjectDownloadPriceError(error))
    
      toast.success("Error Download Price Field is Added");
      toast.dismiss();
  }
}

function* fetchProjectOpenHouseFile( { agentId } ) {
  try {
    const response = yield call(getProjectOpenHouseFile,agentId)
    yield put(getProjectOpenHouseFilesSuccess(response))
  } catch (error) {
    yield put(getProjectOpenHouseFilesFail(error))
  }
}


function* onDeleteProjectOpenHouseFile({ payload:opfile }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteProjectOpenHouseFileUrl, opfile.id)
    yield put(deleteProjectOpenHouseFileSuccess(response))
    toast.dismiss();
    toast.success(" Deleted successfully.");
    const res = yield call(getProjectOpenHouseFile, opfile.agentId)
    yield put(getProjectOpenHouseFilesSuccess(res))
  } catch (error) {
    yield put(deleteProjectOpenHouseFileError(error))
  }
}

function* fetchProjectDPFile( { agentId } ) {
  try {
    const response = yield call(getProjectDPFile,agentId)
    yield put(getProjectDownloadPriceFilesSuccess(response))
  } catch (error) {
    yield put(getProjectDownloadPriceFilesFail(error))
  }
}


function* onDeleteProjectDPFile({ payload: dpfile }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteProjectDPeUrl, dpfile.id)
    yield put(deleteProjectDownloadPriceFileSuccess(response))
    toast.dismiss();
    toast.success(" Deleted successfully.");
    const res = yield call(getProjectDPFile, dpfile.agentId)
    yield put(getProjectDownloadPriceFilesSuccess(res))
  } catch (error) {
    yield put(deleteProjectDownloadPriceFileError(error))
  }
}

function* fetchProjectWorksheetLead({payload: { projectId, statusId}}) {
  try {
    //
    const response = yield call(getProjectWorksheetLeadApi, projectId, statusId)
    yield put(getProjectWorksheetLeadSuccess(response))
  } catch (error) {
    yield put(getProjectWorksheetLeadFail(error))
  }
}

function* fetchProjectWorksheetPurLead({ id }) {
  try {
    //
    const agentId = parseInt(localStorage.getItem("userId"));
    const response = yield call(getProjectWorksheetPurApi, id, agentId)
    yield put(getProjectWorksheetLeadPurDetailSuccess(response))
  } catch (error) {
    yield put(getProjectWorksheetLeadPurDetailFail(error))
  }
}

function* fetchProjectWorksheetUnitLead({ id }) {
  try {
    //
    const agentId = parseInt(localStorage.getItem("userId"));
    const response = yield call(getProjectWorksheetUnitApi, id, agentId)
    yield put(getProjectWorksheetLeadUnitDetailSuccess(response))
  } catch (error) {
    yield put(getProjectWorksheetLeadUnitDetailFail(error))
  }
}

function* fetchProjectWorksheetDocLead({ id }) {
  try {
    //
    const response = yield call(getProjectWorksheetDocApi, id)
    yield put(getProjectWorksheetLeadDocDetailSuccess(response))
  } catch (error) {
    yield put(getProjectWorksheetLeadDocDetailFail(error))
  }
}

function* createProjectInvite({ payload: { data } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectEventInviteAPI, data)
    yield put(addProjectInviteSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const res = yield call(getProjectEventInviteAPI, data.projectGuid)
    yield put(getProjectInviteSuccess(res))
      // history.push("/pre-construction/create-project/feature/" + pr.id + "/" + pr.projectId)
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  } catch (error) {
    yield put(addProjectInviteError(error))
    
      toast.success("Error in Download Price Field ");
      toast.dismiss();
  }
}

function* fetchProjectInvite({ id }) {
  try {
    //
    const response = yield call(getProjectEventInviteAPI, id)
    yield put(getProjectInviteSuccess(response))
  } catch (error) {
    yield put(getProjectInviteError(error))
  }
}

function* fetchProjectInviteDetail({ id }) {
  try {
    //
    const response = yield call(getProjectEventInviteDetailAPI, id)
    yield put(getProjectInviteDetailSuccess(response))
  } catch (error) {
    yield put(getProjectInviteDetailError(error))
  }
}

function* onDeleteProjectInvite({ payload: invitedata }) {
  
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteProjectEventInviteAPI, invitedata.projectEventInviteId)
    yield put(deleteProjectInviteSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getProjectEventInviteAPI, invitedata.projectGuid)
    yield put(getProjectInviteSuccess(res))
  } catch (error) {
    yield put(deleteProjectInviteError(error))
  }
}

function* fetchProjectAttendies({ EventId }) {
  try {
    
    const response = yield call(getProjectInviteAttAPI, EventId)
    yield put(getProjectInviteAttSuccess(response))
  } catch (error) {
    yield put(getProjectInviteAttError(error))
  }
}

function* onUpdateProjectWorsheetUnit({ payload:  project  }) {

  try {
    toast.loading("Please wait...")
    const response = yield call(updatemProjectWorksheetUnitAPI, project)
    toast.dismiss();
    toast.success("Updated successfully.");
  } catch (error) {
    yield put(updateProjectWorksheetUnitError(error))
  }
}


function* fetchWorksheetunitInfo({ id }) {
  try {
    const response = yield call(getWorksheetUnitInfoAPI, id)
    yield put(getProjectWorksheetUnitinfoSuccess(response))
  } catch (error) {
    yield put(getProjectWorksheetUnitinfoFail(error))
  }
}


function* fetchProjectLeadByWorksheetStatus({payload: {  agentId, projectId, unitStatusText, isWorkSheetFilled }}) {
  try {
    //
    const response = yield call(getProjectLeadByWorksheetStatusAPI, agentId, projectId, unitStatusText, isWorkSheetFilled)
    yield put(getProjectLeadByWorsheetStatusSuccess(response))
  } catch (error) {
    yield put(getProjectLeadByWorsheetStatusFail(error))
  }
}

function* onUpdateProjectInvite({ payload:  data  }) {

  try {
    toast.loading("Please wait...")
    const response = yield call(updateProjectEventInviteAPI, data)
    toast.dismiss();
    toast.success("Updated successfully.");
    const res = yield call(getProjectEventInviteAPI, data.projectGuid)
    yield put(getProjectInviteSuccess(res))
  } catch (error) {
    yield put(updateProjectInviteError(error))
  }
}

function* fetchAllProjectladningPage({ agentId }) {
  try {
    //
    const response = yield call(getAllProjectLandingPageApi, agentId)
    yield put(getAllProjectLandingPagesSuccess(response))
  } catch (error) {
    yield put(getAllProjectLandingPagesFail(error))
  }
}


function* createProjectOpenhouseForm({ payload: { data } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postProjectOpenhouseFormAPI, data)
    yield put(addOpenhouseFormSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Successfully Added");
      const res = yield call(getProjectOpenhouseFormAPI, data.projectGuid)
    yield put(getOpenhouseFormSuccess(res))
    
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  } catch (error) {
    yield put(addOpenhouseFormError(error))
    
      toast.success("Error");
      toast.dismiss();
  }
}

function* fetchProjectOpenhouseForm({ id }) {
  try {
    //
    const response = yield call(getProjectOpenhouseFormAPI, id)
    yield put(getOpenhouseFormSuccess(response))
  } catch (error) {
    yield put(getOpenhouseFormError(error))
  }
}

function* projectSaga() {
  yield takeEvery(ADD_PROJECT, createProject)
  yield takeEvery(GET_ALL_PROJECT, fetchAllProject)
  yield takeEvery(ADD_PROJECT_FEATURE, createProjectFeature)
  yield takeEvery(ADD_PROJECT_CONTACT, createProjectContact)
  yield takeEvery(GET_PROJECT_CONTACT, fetchProjectContact)
  yield takeEvery(UPDATE_PROJECT_CONTACT, onProjectContactUpdate)
  yield takeEvery(DELETE_PROJECT_CONTACT, onDeleteContact)
  yield takeEvery(ADD_PROJECT_MEDIA, submitProjectDocument)
  yield takeEvery(GET_PROJECT_MEDIA, fetchProjectDocument)
  yield takeEvery(DELETE_PROJECT_MEDIA, onDeleteDocument)
  yield takeEvery(ADD_PROJECT_MARKET, submitProjectMarket)
  yield takeEvery(GET_PROJECT_MARKET, fetchProjectMarket)
  yield takeEvery(UPDATE_PROJECT_MARKET, onProjectMarketUpdate)
  yield takeEvery(DELETE_PROJECT_MARKET, onDeleteMarket)
  yield takeEvery(GET_ALL_PROJECT_UUID, fetchProjectTab1)
  yield takeEvery(GET_PROJECT_FEATURE, fetchFeatureTab)
  yield takeEvery(GET_PROJECT_FEATURE_STANDARD, fetchFeatureStatandardTab)
  yield takeEvery(DELETE_PROJECT, onDeleteProject)
  yield takeEvery(UPDATE_PROJECT, onUpdateProject)
  yield takeEvery(UPDATE_PROJECT_FEATURE, onUpdateProjectFeature)
  yield takeEvery(UPDATE_PROJECT_FEATURE_STANDARD, onUpdateProjectFeatureStandard)
  yield takeEvery(ADD_PROJECT_LINK, submitProjectLink)
  yield takeEvery(GET_PROJECT_LINK, fetchProjectLink)
  yield takeEvery(UPDATE_PROJECT_LINK, onProjectLinkUpdate)
  yield takeEvery(DELETE_PROJECT_LINK, onDeleteLink)
  yield takeEvery(ADD_PROJECT_GALLERY, submitProjectGallery)
  yield takeEvery(GET_PROJECT_GALLERY, fetchProjectGallery)
  yield takeEvery(DELETE_PROJECT_GALLERY, onDeleteGallery)
  yield takeEvery(GET_ALL_PROJECT_SEARCH, searchProjectAsync)
  yield takeEvery(UPDATE_MPROJECT_STAUS, onUpdateProjectStatus)
  yield takeEvery(DELETE_PROJECT_FEATURE, onDeleteFeature)


  yield takeEvery(ADD_PROJECT_BUDGET_ALLOCATION, submitProjectMarketAllocation)
  yield takeEvery(GET_PROJECT_BUDGET_ALLOCATION, fetchProjectMarketAllocation)
  yield takeEvery(UPDATE_PROJECT_BUDGET_ALLOCATION, onUpdateProjectMarketAllocation)
  yield takeEvery(DELETE_PROJECT_BUDGET_ALLOCATION, onDeleteProjectMarketAllocation)

  yield takeEvery(ADD_PROJECT_BUDGET_SPENT, submitProjectMarketSpent)
  yield takeEvery(GET_PROJECT_BUDGET_SPENT, fetchProjectMarketSpent)
  yield takeEvery(DELETE_PROJECT_BUDGET_SPENT, onDeleteProjectMarketSpent)
  yield takeEvery(UPDATE_PROJECT_BUDGET_SPENT, onUpdateProjectMarketSpent)


  yield takeEvery(ADD_PROJECT_CAMP_LEAD, submitProjectCampLead)
  yield takeEvery(GET_PROJECT_CAMP_LEAD, fetchProjectCampLead)
  yield takeEvery(DELETE_PROJECT_CAMP_LEAD, onDeleteProjectCampLead)

  yield takeEvery(ADD_PROJECT_EMAIL_COMP_FILTER, submitProjectEmailFilter)

  yield takeEvery(ADD_SETTING_WORKSHEET, submitProjectSettingWorksheet)
  yield takeEvery(GET_SETTING_WORKSHEET, fetchProjectSettingWorksheet)
  yield takeEvery(DELETE_SETTING_WORKSHEET, onDeleteProjectSettingWorksheet)

  yield takeEvery(SEND_LEAD_WORKSHEET, submitProjectLeadWorksheet)
  yield takeEvery(GET_ALL_PROJECT_LEAD, fetchAllProjectLead)
  yield takeEvery(GET_ALL_PROJECT_CLIENT, fetchAllProjectClient)

  yield takeEvery(GET_ALL_PROJECT_OPEN_HOUSE_FILE, fetchAllProjectOpenHouseFile)
  yield takeEvery(ADD_PROJECT_OPEN_HOUSE_FILE, createProjectOpenHouseFile)
  yield takeEvery(ADD_PROJECT_OPEN_HOUSE, createProjectOpenHouse)
  yield takeEvery(GET_ALL_PROJECT_OPEN_HOUSE, fetchAllProjectOpenHouse)
  yield takeEvery(GET_PROJECT_OPEN_HOUSE, fetchProjectOpenHouse)
  yield takeEvery(DELETE_PROJECT_OPEN_HOUSE, onDeleteProjectOpenHouse)
  yield takeEvery(UPDATE_PROJECT_OPEN_HOUSE, onUpdateProjectOpenHouse)

  yield takeEvery(GET_PROJECT_OPEN_HOUSE_FILE, fetchProjectOpenHouseFile)
  yield takeEvery(DELETE_PROJECT_OPEN_HOUSE_FILE, onDeleteProjectOpenHouseFile)


  //project Download Price
  
  yield takeEvery(ADD_PROJECT_DOWNLOAD_PRICE_FILE, createProjectDownloadPriceFile)
  yield takeEvery(ADD_PROJECT_DOWNLOAD_PRICE, createProjectDownloadPrice)
  yield takeEvery(GET_ALL_PROJECT_DOWNLOAD_PRICE, fetchAllProjectDownloadPrice)
  yield takeEvery(GET_PROJECT_DOWNLOAD_PRICE, fetchProjectDownloadPrice)
  yield takeEvery(DELETE_PROJECT_DOWNLOAD_PRICE, onDeleteProjectDownloadPrice)
  yield takeEvery(UPDATE_PROJECT_DOWNLOAD_PRICE, onUpdateProjectDownloadPrice)

  yield takeEvery(GET_PROJECT_DOWNLOAD_PRICE_FILE, fetchProjectDPFile)
  yield takeEvery(DELETE_PROJECT_DOWNLOAD_PRICE_FILE, onDeleteProjectDPFile)


  yield takeEvery(GET_PROJECT_WORKSHEET_LEAD, fetchProjectWorksheetLead)

  yield takeEvery(GET_PROJECT_WORKSHEET_LEAD_PUR_DETAIL, fetchProjectWorksheetPurLead)
  yield takeEvery(GET_PROJECT_WORKSHEET_LEAD_UNIT_DETAIL, fetchProjectWorksheetUnitLead)
  yield takeEvery(GET_PROJECT_WORKSHEET_LEAD_DOC_DETAIL, fetchProjectWorksheetDocLead)


  yield takeEvery(POST_PROJECT_INVITE, createProjectInvite)
  yield takeEvery(UPDATE_PROJECT_INVITE, onUpdateProjectInvite)
  yield takeEvery(GET_PROJECT_INVITE, fetchProjectInvite)
  yield takeEvery(DELETE_PROJECT_INVITE, onDeleteProjectInvite)

  yield takeEvery(GET_PROJECT_INVITE_DETAIL, fetchProjectInviteDetail)

  yield takeEvery(VIEW_PROJECT_INVITE_ATTENDEES, fetchProjectAttendies)


  yield takeEvery(UPDATE_PROJECT_WORKSHEET_UNIT, onUpdateProjectWorsheetUnit)
  yield takeEvery(GET_PROJECT_WORKSHEET_UNIT_INFO, fetchWorksheetunitInfo)

  yield takeEvery(GET_PROJECT_LEAD_BY_WORKSHEET_STATUS, fetchProjectLeadByWorksheetStatus)

  yield takeEvery(GET_ALL_PROJECT_LANDING_PAGE, fetchAllProjectladningPage)


  yield takeEvery(POST_PROJECT_OPEN_HOUSE_FORM, createProjectOpenhouseForm)
  yield takeEvery(GET_PROJECT_OPEN_HOUSE_FORM, fetchProjectOpenhouseForm)

}


export default projectSaga
